import React from 'react';
import styles from "./Social.scss";
import fbImg from "./img/fb.png";
import instImg from "./img/inst.png";
import ytImg from "./img/yt.png";
import twImg from "./img/tw.png";
import tikTok from "./img/SH-Web-TikTok-icon-30px.svg";
import linImg from "./img/lin.png";
import {__t} from '../../common/lang/text-resource';

const Social = () => {
	return (

	  <section className={styles.social} data-layout="row start center">

		  <div data-layout="col 12 4@sm 3@md 2@tb text-left margin-right--smm">
			  <img src={fbImg} alt={__t("Facebook страница на СуперХостинг.БГ")}/>
			  <a
				href="https://www.facebook.com/superhosting"
				target="_blank"
				rel="noopener noreferrer"
				title={__t("Страницата на СуперХостинг.БГ във Facebook")}>{__t('Facebook')}</a>
		  </div>

		  <div data-layout="col 12 4@sm 3@md 2@tb text-left margin-right--smm margin-left--smm">
			  <img src={instImg} alt={__t("Instagram профил на СуперХостинг.БГ")}/>
			  <a
				href="https://www.instagram.com/superhosting.bg/"
				target="_blank"
				rel="noopener noreferrer"
				title={__t("Instagram профил")}>{__t('Instagram')}</a>
		  </div>

		  <div data-layout="col 12 4@sm 3@md 2@tb text-left margin-left--xs" className={styles.pull}>
			  <img src={ytImg} alt="YouTube канал"/>
			  <a
				href="https://www.youtube.com/user/SuperHostingBg?sub_confirmation=1"
				target="_blank"
				rel="noopener noreferrer"
				title={__t("YouTube канал")}>{__t('YouTube')}</a>
		  </div>

		  <div data-layout="col 12 4@sm 3@md 2@tb text-left" className={styles.pull}>
			  <img src={tikTok} alt={'TikTok'}/>
			  <a
				href="https://www.tiktok.com/@superhostingbg "
				target="_blank"
				rel="noopener noreferrer"
				title={'TikTok'}>TikTok</a>
		  </div>

		  <div data-layout="col 12 4@sm 3@md 2@tb text-left">
			  <img src={linImg} alt={__t("LinkedIn страница на СуперХостинг.БГ")}/>
			  <a
				href="https://www.linkedin.com/company/319044/admin/updates/"
				target="_blank"
				rel="noopener noreferrer"
				title={__t("LinkedIn страница")}>{__t('LinkedIn')}</a>
		  </div>
	  </section>
	);
};
export default Social;